const mergeAttachments = (...attachmentGroups) =>
  Array.from(
    new Map(
      attachmentGroups
        .flat()
        .filter(attachment => attachment?.filename)
        .map(attachment => [attachment.filename, attachment]),
    ).values(),
  );

export { mergeAttachments };
